import emiter, { _EVENTS } from '../../../events';
import { _APIS } from 'apis';
import request from 'request';
import {Modal, message} from "antd";
import {DEFAULT_PAGE_INFO} from "../../../consts";

export const useBookingRuleTemplate = () => {

	const searchFormReset = (form: any) => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.SEARCH, {
      ...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	};
	const searchFormFinish = (form: any) => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.SEARCH, {
      ...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	};

    const onSearchAction = (load: any) => {
        emiter.on(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.SEARCH, load);
    };

    const search = (params: any) => request.get(_APIS.PRODUCT_PRICE.BOOKING_RULE.SEARCH, { params });

    const update = (params: any) => request.post(_APIS.PRODUCT_PRICE.BOOKING_RULE.EDIT, params);

    const getDetail = (params: any) => request.get(_APIS.PRODUCT_PRICE.BOOKING_RULE.VIEW, { params });

    const deleteData = (params: any) => request.post(_APIS.PRODUCT_PRICE.BOOKING_RULE.DELETE, params);

    const add = (params: any) => request.post(_APIS.PRODUCT_PRICE.BOOKING_RULE.ADD, params);

    const getSaasApolloConfig = (params: any) => request.get(_APIS.PRODUCT_PRICE.COMMON.CONFIG, { params });

    const tablePagination = (data: any) => {
        emiter.emit(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.SEARCH, data);
    }

    const tableActionEdit = async (data: any) => {
        const res = await getDrawerDetail(data)
        emiter.emit(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.EDIT, {
            ...res,
            drawerInfo: {
                disabled: false,
                title: '编辑'
            }
        });
    }

    const tableActionView = async (data: any) => {
        const res = await getDrawerDetail(data)
        emiter.emit(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.VIEW, {
            ...res,
            drawerInfo: {
                disabled: true,
                title: '查看'
            }
        });
    }

    const tableActionAdd = (data: any) => {
        emiter.emit(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.ADD, {
            ...data,
            drawerInfo: {
                disabled: false,
                title: '新建'
            }
        });
    }

    const getDrawerDetail = async (data: any) => {
        if (data.rule_code) {
            const res = await getDetail({
                rule_code: data.rule_code,
            })
            return res.data
        }
    }

    const drawerSubmit = async (data: any, echoData: any) => {
        if (echoData.rule_code) {
            await update({ ...data, rule_code: echoData.rule_code })
        } else {
            await add(data)
        }
        message.success('操作成功');
        emiter.emit(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.SEARCH, {

        });
    }

    const getRelatedGoods = (params: any) => {
        if (params.status === undefined || params.status === '') {
            params.status = -1
        }
        if (params.veh_num_type === undefined || params.veh_num_type === '') {
            params.veh_num_type = -1
        }
        return request.post(_APIS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH,  params)
    };

    const deleteItem = async (data: any) => {
        const { confirm } = Modal;
        const res = await getRelatedGoods({
            rule_code: data.rule_code,
            rule_type: 1,
            page: 1,
            page_size: 1000,
        })
        const total = res?.data?.total
        if (total) {
            message.error('请先解绑应用的车型商品')
        } else {
            confirm({
                title: '确认删除该条预定规则?',
                content: '',
                okText: '确认',
			    cancelText: '取消',
                onOk: async () => {
                    await deleteData({
                        rule_code: data.rule_code,
                    })
                    message.success('操作成功');
                    emiter.emit(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.SEARCH, {

                    });
                },
                onCancel() {
                },
            });

        }
    }

    const openModel = async (data: any) => {
        const res = await getRelatedGoods({
            rule_code: data.rule_code,
            rule_type: 1,
            page: 1,
            page_size: 10000,
        })
        const list = res?.data?.list || []
        if (list.length === 0) {
            message.warning('无关联商品');
        } else {
            emiter.emit(_EVENTS.PRODUCT_PRICE.BOOKING_RULE.OPEN_MODEL, list || []);
        }
    }

    return {
        searchFormReset,
        searchFormFinish,
        search,
        update,
        getDetail,
        deleteData,
        add,
        openModel,
        onSearchAction,
        tablePagination,
        tableActionEdit,
        tableActionView,
        tableActionAdd,
        getDrawerDetail,
        drawerSubmit,
        deleteItem,
        getSaasApolloConfig,
    }
};
